import { ApolloProvider } from "@apollo/client";
import { GraphqlClient } from "../config/apollo";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { StoreState } from "../store/types";

export const GraphQLProvider: React.FC = ({ children }) => {
  const [apollo, setApollo] = useState(GraphqlClient.getInstance());
  const token = useSelector<StoreState, string>((state) => state.token);

  useEffect(() => {
    setApollo(GraphqlClient.getInstance(true));
  }, [token]);

  return <ApolloProvider client={apollo}>{children}</ApolloProvider>;
};
